import { EMenuActionType } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const openMenu = actionGenerator<EMenuActionType.Open>(EMenuActionType.Open);

export const closeMenu = actionGenerator<EMenuActionType.Close>(EMenuActionType.Close);
